var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"},on:{"scroll":_vm.scrollFunction}},[_c('div',{ref:"buttonadd",attrs:{"id":"buttonadd"}},[_vm._v("ADD")]),_c('Header'),_c(_vm.component,{tag:"component"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }